import { graphql } from "@graphql-generated/gql";

export const CloseAlertQueryGraphql = graphql(`
    query CloseAlertQuery($id: ID!) {
        alerteById(id: $id) {
            id
            closingDescription
            dropPoint {
                id
                name
            }
        }
    }
`);

export const CloseAlertMutationGraphql = graphql(`
    mutation ClosingAlert($id: ID!, $closingDescription: String!) {
        closingAlerte(id: $id, closingDescription: $closingDescription) {
            id
            closingDescription
        }
    }
`);
